import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material/";
// import { UserAuth } from "../context/AuthContext";
import { motion, AnimatePresence } from "framer-motion";
import hero from "../assets/landingHero.svg";
import buttonIcon from "../assets/buttonIcon.png";
import Filter from "./Filter";
import mentorSX from './muiStyles/mentorSX.js'
import buttonSX from './muiStyles/buttonSX.js'


const Home = ({
  setFiltered,
  filtered,
  firedata,
  mentorChoice,
  setMentorChoice,
  professionChoice,
  setProfessionChoice,
  handleProfessionChoice,
  handleMentorStatus,
  skillsChoice,
  setSkillsChoice,
  handleHomeSearch,
  handleResultsSearch,
  toggleFilter,
  userData,
  setUserData

}) => {
  // const { signIn } = UserAuth();
  const navigate = useNavigate();

  const handleStart = (type) => {
    setUserData((prev) => ({ ...prev, mentorType: type }));
    navigate("/questionIntro");
  };


  return (
    // <AnimatePresence >
    <>
      <div className="wrapper">
        <motion.main
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ ease: "easeInOut", duration: 1 }}
          className="home"
        >
          <header className="header">
            <h2 className="desktopH2">
              Unlock new <span>growth</span>
            </h2>
            <h3>Find the right fit to take your career to the next level.</h3>
            <h3>Match with mentors from your organization.</h3>
            <Button
              sx={buttonSX}
              onClick={() => handleStart("Mentee")}
              className="button mentee"
              variant="contained"
            >
              <span className="buttonIcon">
                <img src={buttonIcon} alt="button icon" />
              </span>
              Get started
            </Button>
            <Button
              sx={mentorSX}
              onClick={() => handleStart("Mentor")}
              className="button mentor"
              variant="contained"
            >
              
              Become a mentor
            </Button>
          </header>
          <div className="hero">
            <img src={hero} alt="Hero" />
          </div>
          <h2 className="mobileH2">Unlock new <span>growth</span></h2>
        </motion.main>
      </div>

      <Filter
        handleMentorStatus={handleMentorStatus}
        mentorChoice={mentorChoice}
        setMentorChoice={setMentorChoice}
        handleProfessionChoice={handleProfessionChoice}
        setProfessionChoice={setProfessionChoice}
        professionChoice={professionChoice}
        // handleSkillsChoice={handleSkillsChoice}
        setSkillsChoice={setSkillsChoice}
        skillsChoice={skillsChoice}
        firedata={firedata}
        setFiltered={setFiltered}
        filtered={filtered}
        toggleFilter={toggleFilter}
        handleResultsSearch={handleResultsSearch}
        handleHomeSearch={handleHomeSearch}
        displayClose={false}
        routeHome={true}
      />
    </>

    /* </AnimatePresence>  */
  );
};

export default Home;
